import React from 'react';
export var NavigationContext = /*#__PURE__*/React.createContext({
  toggled: false,
  setToggled: function setToggled() {},
  openedDropdownMenus: [],
  setOpenedDropdownMenus: function setOpenedDropdownMenus() {},
  openedAccordionPopups: [],
  setOpenedAccordionPopups: function setOpenedAccordionPopups() {}
});
export var NavigationContextProvider = NavigationContext.Provider;